<template>
  <div class="group-list maxW">
    <router-link to="/group/manage/selfCreated" class="link-entrance fr">圈组管理</router-link>
    <div class="i_courseBox">
      <div class="i_courseSub clear">
        <span>学段</span>
        <div class="i_courseLs clear">
          <label v-for="(item, index) of orgList" :key="item.id" @change="getOrgLevel3(index,item.id)">
            <input type="radio" name="course2" :checked="index == orgChecked ? true : false">
            <span>{{item.name}}</span>
          </label>
        </div>
      </div>
      <div class="i_courseSub clear">
        <span>年级</span>
        <div class="i_courseLs clear">
          <label v-for="(item, index) of orgLevel3" :key="index" @change="getSubjectList(item.id,index)">
            <input type="radio" name="course3" :checked="index == gradeChecked ? true : false">
            <span>{{item.name}}</span>
          </label>
        </div>
      </div>
      <div class="i_courseSub clear">
        <span>科目</span>
        <div class="i_courseLs clear">
          <label v-for="(item, index) of subjectList" :key="item.id" @change="subjectChange(index,item.id)">
            <input type="radio" name="course4" :checked="index == subjectChecked ? true : false">
            <span>{{item.name}}</span>
          </label>
        </div>
      </div>
    </div>
    <div class="i_group_checkbox clear">
        <el-checkbox v-model="radioVal" false-label='null' true-label="true" name="state">我创建的</el-checkbox>
        <el-checkbox v-model="radioVal" false-label='null' true-label="false" name="state">我加入的</el-checkbox>
    </div>
    <div class="i_groupBox">
      <ul>
        <li class="i_groupLs box" v-for="(item,index) of groupListData" :key="index">
          <div class="i_groupLs_img">
            <router-link :to="{path: '/group/introduct', query: {id: item.id}}" :title="item.name">
              <img :src="BASE_URL + item.picture" :onerror="errorImg">
            </router-link>
          </div>
          <div class="i_groupLs_if">
            <router-link :to="{path: '/group/introduct', query: {id: item.id}}" :title="item.name">{{item.name}}</router-link>
            <div class="i_groupLs_info">
              <span>{{item.grade_name}}</span>
              <i>/</i>
              <span>{{item.subject_name}}</span>
            </div>
          </div>
        </li>
      </ul>
      <div class="pageBox">
        <el-pagination v-if="total_number > page_size" @current-change="change_page" :page-size="page_size" :current-page="page_index" layout="total,prev, pager, next,jumper" :total="total_number">
        </el-pagination>
      </div>
    </div>
    <div class="dependent" v-if="placeholder">
      <i class="ipng image_state01"></i>
      <p>还没发现任何相关的圈组哦~</p>
    </div>
  </div>
</template>
   
<script>
export default {
  data() {
    return {
      page_index: 1,
      page_size: 8,
      total_number: 0,
      placeholder: false,
      study_section_id: null,
      grade_id: null,
      subject_id: null,
      orderby: "time",
      create_id: 0,
      gu_status: null,
      radioVal: null,
      orgList: [],
      orgLevel3: [],
      subjectList: [],
      errorImg:
        'this.src="' +
        require("../../../../public/images/image_loding.png") +
        '"',
      checked: false,
      subjectChecked: 0,
      gradeChecked: 0,
      orgChecked: 0,
      groupListData: []
    };
  },
  created() {
    this.getGroupList();
    this.getOrg();
  },
  watch: {
      /**  圈组列表筛选条件
       */
    radioVal(a, b) {
      switch (a) {
        //   我加入的
        case "false":
          this.gu_status = 1;
          this.user_id = this.$store.getters.userInfo.id;
          this.create_id = null;
          this.getGroupList();
          break;
        //   我创建的
        case "true":
          this.gu_status = null;
          this.user_id = null;
          this.create_id = this.$store.getters.userInfo.id;
          this.getGroupList();
          break;
        //   默认显示全部
        case "null":
          this.gu_status = null;
          this.user_id = null;
          this.create_id = 0;
          this.getGroupList();
          break;
      }
    }
  },
  methods: {
    getGroupList() {
      let success = res => {
        let data = res.data;
        this.groupListData = data.data;
        this.total_number = parseInt(data.data_sum);
        this.page_index = parseInt(data.page_index);
        this.groupListData.length === 0
          ? (this.placeholder = true)
          : (this.placeholder = false);
      };
      this.$ajax({
        url: "/api/group/group_list",
        method: "get",
        params: {
          order_type: this.orderby,
          page: this.page_index,
          length: this.page_size,
          study_section_id: this.study_section_id,
          gradeid: this.grade_id,
          subjectid: this.subject_id,
          flag: "home",
          gu_status: this.gu_status,
          user_id:this.user_id,
          create_id: this.create_id,
          status: 1
        },
        func: { success: success }
      });
    },

    //获取学段
    getOrg() {
      let params = {
        level: 2,
        pid: 1,
        direction: "balance",
        is_diffplat: 1
      };
      const success = res => {
        // console.log(res)
        this.orgList = res.data;
        this.orgList.unshift({ id: 0, name: "全部" });
        this.getOrgLevel3(this.orgList[0].id);
        this.getGroupList();
      };
      this.$ajax.get("api/org/org", {
        params: params,
        func: { success: success }
      });
    },
    //获取年级
    getOrgLevel3(index, study_section_id) {
      this.orgChecked = index;
      let params = {
        level: 3,
        pid: study_section_id == 0 ? undefined : study_section_id,
        direction: "balance"
      };
      const success = res => {
        this.orgLevel3 = res.data;
        this.orgLevel3.unshift({ id: 0, name: "全部" });
        this.getSubjectList(this.orgLevel3[0].id);
        (this.study_section_id = study_section_id), this.getGroupList();
      };
      this.$ajax.get("api/org/org", {
        params: params,
        func: { success: success }
      });
    },
    //获取学科
    getSubjectList(orgid, _index) {
      if (_index == undefined) {
        this.gradeChecked = 0;
      } else {
        this.gradeChecked = _index;
      }
      let params = {
        type: 2,
        subject_id: orgid === orgid ? orgid : null,
        status: 1
      };
      const success = res => {
        this.subjectList = res.data;
        this.subjectList.unshift({ id: 0, name: "全部" });
        this.grade_id = orgid;
        this.getGroupList();
      };
      this.$ajax.get("api/cate/subject", {
        params: params,
        func: { success: success }
      });
    },
    subjectChange(index, id) {
      this.subjectChecked = index;
      this.subject_id = id;
      this.getGroupList();
    },
    change_page(val) {
      this.page_index = val;
      this.getGroupList();
    }
  }
};
</script>
